<div class="side-sheet" [ngClass]="{'active': open}">
  <div class="d-flex h-100">

    <div class="overlay" (click)="close.emit()"></div>

    <div class="sheet-container ">
      <div class="sheet-head dark-blue-background white-color">
        <div class="title">{{'servers.Servers' | translate}} <span *ngIf="servers.length">({{servers.length}})</span>
        </div>

        <button type="button" mat-icon-button (click)="close.emit()">
          <img src="./assets/images/icons/close.svg" alt="">
        </button>
      </div>
      <div *ngIf='dataLoading' class="dataLoading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
      </div>

      <div class="server-details">
        <ng-container *ngIf="!dataLoading">
          <div class="list" *ngIf="servers && servers?.length; else dataEmpty">
            <div class="list-item" *ngFor="let server of servers">
              <div class="d-flex">
                <div class="img-card">
                  <span class="font-14 fontMedium" *ngIf="!server.profilePic"> {{server.name | shortName}} </span>
                  <img *ngIf="server.profilePic" [src]="server.profilePic" (error)="server.profilePic = ''">
                </div>
                <div class="server-content">
                  <p class="font-16 fontMedium">{{server.name}}</p>
                  <p class="font-14 fontRegular grey-color" *ngIf="server.tabelsNames">{{server.tabelsNames}}</p>
                  <p class="font-14 fontRegular grey-color" *ngIf="!server.tabelsNames">{{'content4.N/A' | translate }}</p>
                </div>
              </div>
            </div>
           
          </div>
          <ng-template #dataEmpty>
            <empty-state [title]='"general.No Data Found" | translate'></empty-state>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>
</div>